import { render } from "./ViewPracticePhoneticConsonant.vue?vue&type=template&id=c86f6d22&scoped=true"
import script from "./ViewPracticePhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./ViewPracticePhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/views/view-practice-phonetic-consonant.css?vue&type=style&index=0&id=c86f6d22&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86f6d22"]])

export default __exports__